export enum BuilderTimePeriodEnum {
  PER_WEEK = "per week",
  PER_MONTH = "per month",
}
